module.exports = __webpack_public_path__ + "img/dep_graph_version.7b4e7e6f.png";